//
// Tabs
// ================================================================================

function tabs() {

    // Get all Tabs groups
    const allTabsGroups = document.querySelectorAll('[data-tabs="true"]');

    allTabsGroups.forEach( (tabGroup) => {

        // Getting elements as arrays
        const tabs = [...tabGroup.querySelectorAll('[role="tab"]')];
        const panels = [...tabGroup.querySelectorAll('[role="tabpanel"]')];
        const panelsContainer = panels[0].parentElement;
        let panesMaxHeight = 0;

        // Set the panels area height and hide them
        panels.forEach(panel => {
            panesMaxHeight = panel.scrollHeight > panesMaxHeight ? panel.scrollHeight : panesMaxHeight;
            panel.setAttribute('hidden', true);

            ///////////////
            console.log(panesMaxHeight);
        })

        panelsContainer.style.height = panesMaxHeight + 'px';

        // Activate first Tab and Panel
        // * Sometimes there aren't any tabs
        if (tabs[0]) {
            tabs[0].setAttribute('aria-selected', true);
            tabs[0].setAttribute('tabindex', '0');
            tabs[0].classList.add('--is-active');
            tabs[0].removeAttribute('hidden');
            tabGroup.querySelector(`#${ tabs[0].getAttribute("aria-controls") }`).removeAttribute('hidden');
        }

        // Attach tab's event listener
        tabs.forEach( (tab) => {

            tab.addEventListener('click', () => {
                // Check if it's already selected
                if (tab.getAttribute('aria-selected') == 'false') {
                    showTab(tab);
                }
            });

            // Keyboard arrow navigation
            const firstTab = tabs[0];
            const lastTab = tabs[ tabs.length -1 ];

            tab.addEventListener('keydown', function (e) {

                // Ready for both aria-orientation="vertical" or "horizontal"
                // if Left Arrow (37) or Up Arrow (38)
                if ((e.keyCode || e.which) === 38 || (e.keyCode || e.which) === 37) {
                    e.preventDefault();
                    if (tab == firstTab) {
                        lastTab.focus();
                    } else {
                        const previousTab = tabs.indexOf(tab) - 1;
                        tabs[previousTab].focus();
                    }
                // if Right Arrow (39) or Down Arrow (40)
                } else if ((e.keyCode || e.which) === 40 || (e.keyCode || e.which) === 39) {
                    e.preventDefault();
                    if (tab == lastTab) {
                        firstTab.focus();
                    } else {
                        const nextTab = tabs.indexOf(tab) + 1;
                        tabs[nextTab].focus();
                    }
                }
            })
        });

        // Define tab panels tabindex depending on their elements
        //
        // https://www.w3.org/WAI/ARIA/apg/patterns/tabpanel/
        // When the tab list contains the focus, [tab] moves focus to the
        // next element in the page tab sequence outside the tablist,
        // which is the tabpanel unless the first element containing
        // meaningful content inside the tabpanel is focusable.
        panels.forEach( (panel) => {
            const focusableElements = panel.querySelectorAll(
                'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled]), details:not([disabled]), summary:not(:disabled)'
            ).length;

            focusableElements
                ? panel.setAttribute("tabindex", "-1")
                : panel.setAttribute("tabindex", "0");
        });
    });




    function showTab(tab) {

        // Hide active tab and panel
        const tabGroup = tab.closest('[data-tabs="true"]');
        const activeTab = tabGroup.querySelector('button[aria-selected="true"]');
        const activePanel = tabGroup.querySelector(`#${ activeTab.getAttribute("aria-controls") }`);

        activeTab.setAttribute('aria-selected', false);
        activeTab.classList.remove('--is-active');
        activeTab.setAttribute('tabindex', '-1');
        activePanel.setAttribute('hidden', true);

        // Show clicked tab
        const targetPanel = tabGroup.querySelector(`#${ tab.getAttribute("aria-controls") }`);

        tab.setAttribute('aria-selected', true);
        tab.setAttribute('tabindex', '0');
        tab.classList.add('--is-active');
        targetPanel.removeAttribute('hidden');
    }
}

export { tabs }
